<div class="context-box">
    <div class="progress"><mat-progress-bar mode="indeterminate" *ngIf="(loading$ | async) || (overdueLoading$ | async)"></mat-progress-bar></div>

    <div class="title">Doings {{ overdueDoingCount }} / {{ doingCount }}</div>

    <div class="flex -mx-1">
        <mat-form-field appearance="outline" class="no-hints">
            <input matInput #doingSearchInput type="search" placeholder="Suche" ngModel (ngModelChange)="queryChanged($event)" />
            <div matSuffix [matMenuTriggerFor]="doingTypeMenu" class="pr-3 text-sm text-gray-700 font-bold cursor-pointer">
                <ng-container [ngSwitch]="(selectedDoingSubtype$ | async)">
                    <span *ngSwitchCase="'all'">Alle</span>
                    <span *ngSwitchCase="'management'">Management</span>
                    <span *ngSwitchCase="'event'">Event</span>
                </ng-container>
            </div>
            <mat-menu #doingTypeMenu>
                <div mat-menu-item (click)="changeSubtype('all')">Alle</div>
                <div mat-menu-item (click)="changeSubtype('management')">Management</div>
                <div mat-menu-item (click)="changeSubtype('event')">Event</div>
            </mat-menu>
        </mat-form-field>
    </div>

    <div>
        <mat-checkbox ngModel (ngModelChange)="changeShowArchivedDoings($event)" [checked]="(showArchivedDoings$ | async)">Archiviert</mat-checkbox>
    </div>



    <div class="bg-orange-500 text-sm py-1 px-3 rounded-lg font-bold inline-block text-white mb-2">
        <div class="inline-block mr-1" *ngIf="(overdueLoading$ | async)">
            <span class="iconify" data-icon="svg-spinners:180-ring"></span>
        </div>
        Überfällig
    </div>
    <div #overdueDoingScrollContainer style="max-height:40vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onOverdueDoingScroll()">
        <app-doing [doing]="doing" *ngFor="let doing of (overdueDoings$ | async); trackBy: identify" (followUpAdded)="moveOverdueToNormal(doing)"></app-doing>
    </div>

    <div class="bg-blue-500 text-sm py-1 px-3 rounded-lg font-bold inline-block text-white mt-4 mb-2">
        <div class="inline-block mr-1" *ngIf="(loading$ | async)">
            <span class="iconify" data-icon="svg-spinners:180-ring"></span>
        </div>
        Doings
    </div>
    <div #doingScrollContainer style="max-height:40vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onDoingScroll()">
        <app-doing [doing]="doing" *ngFor="let doing of (doings$ | async); trackBy: identify"></app-doing>
    </div>

    <div class="mt-3 p-2 border-2 border-gray-500 bg-gray-200 rounded-lg">
        <app-doing-form [(ngModel)]="newDoing" [cooperationSearchEnabled]="true" [customerSearchEnabled]="true" [userSearchEnabled]="true" [placeholderText]="'Neues Doing hinzufügen'" (doingSubmitted)="addDoing($event)"></app-doing-form>
    </div>
</div>
